import concat from "lodash/concat";
import includes from "lodash/includes";
import without from "lodash/without";

import firebase from "./firebase";

const db = firebase.firestore();
export const usersCollection = db.collection("users");

export function insertCurrentUserOnLogin() {
    firebase.auth().onAuthStateChanged(async user => {
        if (!user) {
            return;
        }

        if (!user.email.includes("@mondora.com")) {
            return;
        }

        const { currentUser } = firebase.auth();
        const userObject = {
            id: currentUser.uid,
            name: currentUser.displayName,
            photoURL: currentUser.photoURL
        };
        await usersCollection
            .doc(currentUser.uid)
            .set(userObject, { merge: true });
    });
}

export async function toggleCurrentUserConnectionWith(userId) {
    const { currentUser } = firebase.auth();
    await db.runTransaction(async transaction => {
        const userRef = usersCollection.doc(currentUser.uid);
        const user = (await transaction.get(userRef)).data();
        const currentConnections = user.connections || [];
        const nextConnections = includes(currentConnections, userId)
            ? without(currentConnections, userId)
            : concat(currentConnections, userId);
        await transaction.update(userRef, { connections: nextConnections });
    });
}

export function getAllUsersQuery() {
    return usersCollection;
}



// WEBPACK FOOTER //
// ./src/common/usersService.js